import { useTranslation } from "react-i18next";
import { Button, Dropdown, Form, Layout, MenuProps, Modal, Popconfirm, Space, Switch, TableColumnsType, TableProps, Tabs, TabsProps, Tag, Typography, message } from "antd";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, LoadingOutlined, MoreOutlined, SaveOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib";
import { routesConfig } from "../../../config/routes";
import { DataType, validateFieldCreate } from "./constants/data";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import DrawerCustom from "../../../components/drawer/Drawer";
import { formatDateV2 } from "../../../utils/converDate";
import { get, isEmpty } from "lodash";
import { addMoocAddressDistrict, addMoocAddressProvince, addMoocAddressWard, deleteMoocAddressDistrict, deleteMoocAddressProvince, deleteMoocAddressWard, downloadMoocDistrictTemplateFile, downloadMoocProvinceTemplateFile, downloadMoocWardTemplateFile, exportExcelMoocDistrict, exportExcelMoocProvince, exportExcelMoocWard, getAllMoocAddressDistrictByFilter, getAllMoocAddressProvinceByFilter, getAllMoocAddressWardByFilter, getMoocAddressDistrictByCode, getMoocAddressProvinceByCode, getMoocAddressWardByCode, importExcelMoocDistrict, importExcelMoocProvince, importExcelMoocWard, updateMoocAddressDistrict, updateMoocAddressProvince, updateMoocAddressWard } from "../../../service/category-management/administrative-unit-management";
import FilterTable from "./components/filter-table/FilterTable";
import FormFilter from "./components/filter-group/FormFilter";
import FormCreateAdministrativeUnit from "./components/form-create-administrative-unit/FormCreateAdministrativeUnit";
import "./administrative-unit-management.scss";
import { exportFileExcel } from "../../../utils/exportExcel";

type AdministrativeUnitManagementProps = {
  title?: string;
};

const AdministrativeUnitManagement = ({ title }: AdministrativeUnitManagementProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [params, setParams] = useSearchParams();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isRendering, setIsRendering] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [tab, setTab] = useState("1");
  const navigate = useNavigate();
  const [editId, setEditId] = useState<number>(0);
  const [dataDetail, setDataDetail] = useState<any>({});
  const [textRendered, setTextRendered] = useState("");
  const [dataProvince, setDataProvince] = useState<any>([]);
  const [dataDistrict, setDataDistrict] = useState<any>([]);
  const [dataWard, setDataWard] = useState<any>([]);
  const [previousCode, setPreviousCode] = useState<string>();
  const [dataDistrictFilter, setDataDistrictFilter] = useState([]);
  const [isEmptyDistrict, setIsEmptyDistrict] = useState<boolean>(false);
  const [isEmptyWard, setIsEmptyWard] = useState<boolean>(false);

  const [dataOptions, setDataOptions] = useState<any>({
    dataProvince: [],
    dataDistrict: [],
  })

  const [filterData, setFilterData] = useState<any>({
    districtCode: null,
    provinceCode: null,
    createdDateFrom: null,
    createdDateTo: null,
  });

  const administrativeUnitsOptions: MenuProps["items"] = [
    {
      key: "1",
      label: t("Sửa", "Sửa"),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Xóa", "Xóa"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: t("STT", "STT"),
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên", "Tên"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 30,
      className:"title-sequence",
      render: (_: any, record) => {
        return (
          <div className="table-administrative-unit cursor-pointer">
            <div>
              <a
                className="administrative-unit-name"
                onClick={() =>
                  navigate(
                    `${routesConfig.administrativeUnitManagementDetail}/${record?.code}`,
                    {
                      state: {
                        mode: "view",
                        tab: tab,
                        record,
                        name: record.name,
                        textRendered: textRendered,
                      },
                    }
                  )
                }
              >
                {record.name}
              </a>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Mã", "Mã"),
      dataIndex: "code",
      key: "code",
      className:"title-sequence",
      width: 20,
    },
    {
      title: t("Tên đầy đủ", "Tên đầy đủ"),
      dataIndex: "fullName",
      key: "fullName",
      className:"title-sequence",
      width: 20,
    },
    {
      title: t("Tên tiếng Anh", "Tên tiếng Anh"),
      dataIndex: "fullNameEn",
      key: "fullNameEn",
      className:"title-sequence",
      width: 20,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any, index: number) => {
        return record.createdDate ? formatDateV2(record.createdDate) : null;
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.administrativeUnitManagementDetail}/${record?.code}`,
                    {
                      state: {
                        mode: "view",
                        tab: tab,
                        record,
                        name: record.name,
                        textRendered: textRendered,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: administrativeUnitsOptions,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      getAdministrativeUnitToUpdate(record.code);
                      handleOpenEdit(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: `${t("Xóa", "Xóa")} ${textRendered}`,
                        content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                        onOk: () => deleteAdministrativeUnit(record),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 20,
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản trị danh mục", "Quản trị danh mục"),
    },
  ];

  // Get data AdministrativeUnit
  // Fetch data Province
  const getAllMoocAddressProvince = () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      createdDateFrom: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['name, asc'] : [`${fieldSortOrder},${statusOrder}`],
    };
    getAllMoocAddressProvinceByFilter(dataReq).then((res) => {
      if(res.status === 200) {
        const listDataProvince = res.data?.data?.content?.map((item: any) => {
          return {
            code: item.code,
            name: item.name,
            fullName: item.fullName,
          }
        })
        setDataProvince(res.data?.data?.content);
        setTotalRecords(res.data?.data?.totalElements);
        setDataOptions({
          ...dataOptions,
          dataProvince: listDataProvince,
        })
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
    }).catch((err) => {
      if (err.response?.status === 400) {
        navigate("/error/403");
      } else {
        console.error(err);
      }
      setLoading(false);
    }).finally(() => {setLoading(false);});
  };

  // Fetch data District
  const getAllMoocAddressDistrict = () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      provinceCode: filterData.provinceCode,
      createdDateFrom: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['name, asc'] : [`${fieldSortOrder},${statusOrder}`],
    };
    getAllMoocAddressDistrictByFilter(dataReq).then((res) => {
      if(res.status === 200) {
        setDataDistrict(res.data?.data?.content);
        setTotalRecords(res.data?.data?.totalElements);
        setIsEmptyDistrict(isEmpty(res.data?.data?.content));
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
    }).catch((err) => {
      if (err.response?.status === 400) {
        navigate("/error/403");
      } else {
        console.error(err);
      }
      setLoading(false);
    }).finally(() => {setLoading(false);});
  };

  // Fetch data Ward
  const getAllMoocAddressWard = () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      districtCode: filterData.districtCode,
      createdDateFrom: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['name, asc'] : [`${fieldSortOrder},${statusOrder}`],
    };
    if(dataDistrict === null) {
      // Call the API to fetch district data when entering tab 3 without accessing tab 2 (Step 1)
      getAllMoocAddressDistrict();
    } else if(filterData.districtCode) {
      getAllMoocAddressWardByFilter(dataReq).then((res) => {
        if(res.status === 200) {
          setDataWard(res.data?.data?.content);
          setTotalRecords(res.data?.data?.totalElements);
          setIsEmptyWard(isEmpty(res.data?.data?.content));
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
      }).catch((err) => {
        if (err.response?.status === 400) {
          navigate("/error/403");
        } else {
          console.error(err);
        }
        setLoading(false);
      }).finally(() => {setLoading(false);});
    } else {
      setIsEmptyWard(true);
      setLoading(false);
    }
  };

  // Switch call API
  const getAllData = () => {
    switch(tab) {
      case "1":
        getAllMoocAddressProvince();
        break;
      case "2":
        getAllMoocAddressDistrict();
        break;
      case "3":
        getAllMoocAddressWard();
        break
      default:
        break;
    }
  }
  
  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = (form: FormInstance) => {
    form.setFieldsValue({ time: null });
    setFilterData({
      ...filterData,
      createdDateFrom: null,
      createdDateTo: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllData();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllData();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setDataOptions({
      ...dataOptions,
      dataDistrict: dataDistrictFilter,
    });
    setFilterData({
      ...filterData,
      districtCode: values?.district,
      provinceCode: values?.province,
      createdDateFrom: values?.time ? (values?.time[0]).add(1, "day").toISOString() : null,
      createdDateTo: values?.time ? (values?.time[1]).add(1, "day").toISOString() : null,
    });
  };

  // Get AdministrativeUnit to edit
  const getAdministrativeUnitToUpdate = async (code: string) => {
    setLoadingForm(true);
    switch (tab) {
      case "1":
        await getMoocAddressProvinceByCode(code).then((res) => {
          const { data } = res.data;
          setDataDetail(data);
          setPreviousCode(data?.code);
          setTimeout(() => {
            setLoadingForm(false);
          }, 333);
        })
          .catch((err) => {
            setLoadingForm(false);
            console.error(err);
        });
        break;
      case "2":
        await getMoocAddressDistrictByCode(code).then((res) => {
          const { data } = res.data;
          setDataDetail(data);
          setPreviousCode(data?.code);
          setTimeout(() => {
            setLoadingForm(false);
          }, 333);
        })
          .catch((err) => {
            setLoadingForm(false);
            console.error(err);
        });
        break;
      case "3":
        await getMoocAddressWardByCode(code).then((res) => {
          const { data } = res.data;
          setDataDetail(data);
          setPreviousCode(data?.code);
          setTimeout(() => {
            setLoadingForm(false);
          }, 333);
        })
          .catch((err) => {
            setLoadingForm(false);
            console.error(err);
        });
        break;
      default:
        break;
    }
  };

  // Modal create | edit
  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenEdit = (id: number) => {
    setEditId(id);
    setIsOpened(true);
    setIsOpenedEdit(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setIsOpenedEdit(false);
    form.resetFields();
  };

  const handleCreateAndEdit = () => {
    Modal.confirm({
      title: !isOpenedEdit ? `${t("Thêm mới", "Thêm mới")} ${textRendered}` : `${t("Chỉnh sửa", "Chỉnh sửa")} ${textRendered}`,
      content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu"),
      onOk: () => form.submit(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  }

  const onFinishCreate = async (values: any) => {
    if (Object.keys(values).length > 0) {
      if (isOpenedEdit) {
        let dataPayload = {
          id: editId,
          code: values.code.trim(),
          previousCode: previousCode,
          name: values.name.trim(),
          nameEn: values.nameEn.trim(),
          fullName: values.fullName.trim(),
          fullNameEn: values.fullNameEn.trim(),
          codeName: values.codeName.trim(),
        };
        setIsSaving(true);
        try {
          switch (tab) {
            case "1":
              await updateMoocAddressProvince(dataPayload).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Cập nhật thành công!", "Cập nhật thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressProvince();
              })
              break;

            case "2":
              const dataPayloadDistrict = {...dataPayload, provinceCode: values?.province?.trim()};
              await updateMoocAddressDistrict(dataPayloadDistrict).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Cập nhật thành công!", "Cập nhật thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressDistrict();
              })
              break;

            case "3":
              const dataPayloadWard = {...dataPayload, districtCode: values?.district?.trim()}
              await updateMoocAddressWard(dataPayloadWard).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Cập nhật thành công!", "Cập nhật thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressWard();
              })
              break;
            default:
              break;
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      } else {
        const dataPayload = {
          code: values.code.trim(),
          previousCode: null,
          name: values.name.trim(),
          nameEn: values.nameEn.trim(),
          fullName: values.fullName.trim(),
          fullNameEn: values.fullNameEn.trim(),
          codeName: values.codeName.trim(),
        };
        setIsSaving(true);
        try {
          switch (tab) {
            case "1":
              await addMoocAddressProvince(dataPayload).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressProvince();
              })
              break;
            case "2":
              const dataPayloadDistrict = {...dataPayload, provinceCode: values?.province?.trim()}
              await addMoocAddressDistrict(dataPayloadDistrict).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressProvince();
              })
              break;

            case "3":
              const dataPayloadWard = {...dataPayload, districtCode: values?.district?.trim()}
              await addMoocAddressWard(dataPayloadWard).then((res) => {
                const { success } = res.data;
                if (success) {
                  message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
                } else {
                  message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
                }
                handleClose();
                getAllMoocAddressProvince();
              })
              break;
            default:
              break;
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      }
    }
  };

  // Delete AdministrativeUnit
  const deleteAdministrativeUnit = async (administrativeUnit: any) => {
    try {
      switch (tab) {
        case "1":
          await deleteMoocAddressProvince(administrativeUnit.code).then((res) => {
            if (res.status === 200) {
              message.success(t("Xóa thành công!", "Xóa thành công!"));
              getAllMoocAddressProvince();
            }
          });
          break;
        case "2":
          await deleteMoocAddressDistrict(administrativeUnit.code).then((res) => {
            if (res.status === 200) {
              message.success(t("Xóa thành công!", "Xóa thành công!"));
              getAllMoocAddressDistrict();
            }
          });
          break;
        case "3":
          await deleteMoocAddressWard(administrativeUnit.code).then((res) => {
            if (res.status === 200) {
              message.success(t("Xóa thành công!", "Xóa thành công!"));
              getAllMoocAddressWard();
            }
          });
          break;
        default:
          break;
      }
    } catch (err) { }
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // tab items
  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: <div>{t("Cấp tỉnh", "Cấp tỉnh")}</div>,
      children: (
        <div className="province-tab">
          <TableData
            pagination={true}
            pageSize={pageSize}
            hideSelection={false}
            dataTable={dataProvince}
            pageNumber={pageNumber}
            dataColumns={dataColumns}
            loadingTable={loading}
            setPageSize={setPageSize}
            scroll={{ x: 1500, y: 800 }}
            setPageNumber={setPageNumber}
            totalRecords={totalRecords}
            handleTableChangeProps={handleTableChange}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: <div>{t("Cấp huyện", "Cấp huyện")}</div>,
      children: (
        <div className="district-tab">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={dataDistrict}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
          />
        </div>
      ),
    },
    {
        key: "3",
        label: <div>{t("Cấp xã", "Cấp xã")}</div>,
        children: (
          <div className="district-tab">
            <TableData
              dataColumns={dataColumns}
              loadingTable={loading}
              dataTable={dataWard}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              totalRecords={totalRecords}
              scroll={{ x: 1500, y: 800 }}
              pagination={true}
              hideSelection={false}
              handleTableChangeProps={handleTableChange}
            />
          </div>
        ),
      },
  ];

  // Handle change tab
  const onChangeTab = (key: string) => {
    setTab(key);
    setPageNumber(1);
    form.resetFields();
  };

  // Export file Excel
  const exportExcel = () => {
    const dataReq = {
      keyword: searchValue.trim(),
      createdFromDate: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdToDate: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['name, asc'] : [`${fieldSortOrder},${statusOrder}`],
    };
    switch (tab) {
      case "1":
        exportFileExcel(exportExcelMoocProvince, dataReq, t("Danh sách đơn vị hành chính cấp Tỉnh", "Danh sách đơn vị hành chính cấp Tỉnh"), setIsRendering);
        break;
      case "2":
        const provinceFullName = get(dataOptions, "dataProvince")?.find((item: any) => item?.code === filterData.provinceCode)?.fullName;
        const dataReqDistrict = {...dataReq, provinceCode: filterData.provinceCode};
        exportFileExcel(exportExcelMoocDistrict, dataReqDistrict, `${t("Danh sách đơn vị hành chính cấp Huyện của", "Danh sách đơn vị hành chính cấp Huyện của")} ${provinceFullName}`, setIsRendering);
        break;
      case "3":
        const districtFullName = get(dataOptions, "dataDistrict")?.find((item: any) => item?.code === filterData.districtCode)?.fullName;
        const dataReqWard = {...dataReq, districtCode: filterData.districtCode};
        exportFileExcel(exportExcelMoocWard, dataReqWard, `${t("Danh sách đơn vị hành chính cấp Xã của", "Danh sách đơn vị hành chính cấp Xã của")} ${districtFullName}`, setIsRendering);
        break;
      default:
        break;
    }
  };

  // Import file Excel to add new
  const importExcel = async (file: any) => {
    setLoading(true);
    switch (tab) {
      case "1":
        await importExcelMoocProvince(file).then((res) => {
          if (res.status === 200) {
            message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
            setLoading(false);
            setTimeout(() => {
              setLoading(false);
            }, 300);
            getAllData();
          }
        }).catch((err) => {
          {
            setLoading(false);
            console.error(err);
          }
        })
        break;
      case "2":
        await importExcelMoocDistrict(file).then((res) => {
          if (res.status === 200) {
            message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
            setLoading(false);
            setTimeout(() => {
              setLoading(false);
            }, 300);
            getAllData();
          }
        }).catch((err) => {
           {
            setLoading(false);
            console.error(err);
          }
        })
        break;
      case "3":
        await importExcelMoocWard(file).then((res) => {
          if (res.status === 200) {
            message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
            setLoading(false);
            setTimeout(() => {
              setLoading(false);
            }, 300);
            getAllData();
          }
        }).catch((err) => {
          {
            setLoading(false);
            console.error(err);
          }
        })
        break;
      default:
        break;
    }
   }

   // Download file template excel
    const handleDownloadFile = async () => {
      try {
        await (tab === "1" ? 
          downloadMoocProvinceTemplateFile() : 
          tab === "2" ?
          downloadMoocDistrictTemplateFile() :
          downloadMoocWardTemplateFile()
        ).then((res) => {
          const fileData = res.data;
  
          const blob = new Blob([fileData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
  
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
  
          downloadLink.download = `${t("Mẫu thêm mới", "Mẫu thêm mới")} ${
            `${t("Danh sách đơn vị hành chính", "Danh sách đơn vị hành chính")} ${tab === "1" ? t("cấp Tỉnh", "cấp Tỉnh") :  
            tab === "2" ? t("cấp Huyện", "cấp Huyện") : t("cấp Xã", "cấp Xã")}`}.xlsx`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          // message.success(t("Tải xuống thành công!", "Tải xuống thành công!"))
        })
      } catch (err) {
        console.error("Error downloading Excel file:", err);
      }
    }  

  // useEffect
  useEffect(() => {
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        code: dataDetail.code,
        codeName: dataDetail.codeName,
        name: dataDetail.name,
        fullName: dataDetail.fullName,
        nameEn: dataDetail.nameEn,
        fullNameEn: dataDetail.fullNameEn,
        province: dataDetail.provinceCode,
        district: dataDetail.districtCode,
      });
    }
  }, [dataDetail]);

  // Call the API to fetch ward data after retrieving district data when in tab 3 (Step 2)
  useEffect(() => {
    if(tab === "3") {
      getAllMoocAddressWard();
    }
  },[dataDistrict]);

  useEffect(() => {
    getAllData();
  }, [pageNumber, pageSize, filterData, statusOrder]);

  useEffect(() => {
    switch (tab) {
      case "1":
        // getAllData();
        setTextRendered(t("đơn vị cấp Tỉnh", "đơn vị cấp Tỉnh"));
        break;
      case "2":
        setShowFilter(true);
        setFilterData({
          ...filterData,
          provinceCode: get(dataOptions, "dataProvince")?.[0]?.code,
        })
        setTextRendered(t("đơn vị cấp Huyện", "đơn vị cấp Huyện"));
        break;
      case "3":
        setShowFilter(true);
        setFilterData({
          ...filterData,
          provinceCode: get(dataOptions, "dataProvince")?.[0]?.code,
        })
        setTextRendered(t("đơn vị cấp Xã", "đơn vị cấp Xã"));
      break;
      default:
        break;
    }
  }, [tab]);

  useEffect(() => {
    Promise.all([
      getAllMoocAddressProvinceByFilter({sort:["name, asc"]}),
    ])
    .then((res) => {
      const listDataProvince = res[0].data?.data?.content?.map((item: any) => {
        return {
          code: item.code,
          name: item.name,
          fullName: item.fullName,
        }
      });

      setDataOptions({
        ...dataOptions,
        dataProvince: listDataProvince,
      });
    })
  }, []);

  return (
    <Layout className="page-header-group">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createAdministrativeUnit") {
            const { createAdministrativeUnit } = forms;
            const data = createAdministrativeUnit.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
        }}
      >
        <div className={`page-header-group--layout ${showFilter ? "open-filter" : ""}`} >
          <div className="table-header--wrapper">
            <div className="table-header--left">
                <PageHeader 
                  title={
                    `${t("Danh sách đơn vị hành chính", "Danh sách đơn vị hành chính")} ${tab === "1" ? t("cấp Tỉnh", "cấp Tỉnh") : tab === "2" ? t("cấp Huyện", "cấp Huyện") : t("cấp Xã", "cấp Xã")}`
                  } 
                  listBreadcrumb={listBreadcrumb} 
                />
            </div>
            <FilterTable
              tab={tab}
              searchValue={searchValue}
              isRendering={isRendering}
              isEmptyWard={isEmptyWard}
              isEmptyDistrict={isEmptyDistrict}
              importExcel={importExcel}
              exportExcel={exportExcel}
              handleSearch={handleSearch}
              handleOpen={handleOpenCreate}
              handleOpenFilter={handleOpenFilter}
              handleDownloadFile={handleDownloadFile}
              handleSubmitSearch={handleSubmitSearch}
              handleChangeInput={handleChangeInput}
            />
          </div>
          <FormFilter
            tab={tab}
            showFilter={showFilter}
            filterData={filterData}
            dataOptions={dataOptions}
            onFinish={handleFinish}
            clearFilter={clearFilter}
            setFilterData={setFilterData}
            setDataOptions={setDataOptions}
            setDataDistrictFilter={setDataDistrictFilter}
          />
        </div>

        <div className="tabs-heading">
          <Tabs items={itemsTab} activeKey={tab} onChange={onChangeTab} />
        </div>
        <DrawerCustom 
          title={`${isOpenedEdit ? t("Chỉnh sửa", "Chỉnh sửa") : t("Thêm mới", "Thêm mới")} ${textRendered}`}
          open={isOpened}
          onClose={handleClose}
          extraNode={
            <Space>
              <Button onClick={handleClose} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary" htmlType="submit" onClick={handleCreateAndEdit} disabled={isSaving}>
                {isSaving ? <LoadingOutlined /> : <SaveOutlined />}
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
          widthDrawer={690}
        >
          <FormCreateAdministrativeUnit form={form} loadingForm={loadingForm} tab={tab} textRendered={textRendered} dataOptions={dataOptions}/>
        </DrawerCustom>
      </Form.Provider>
    </Layout>
    
  );
};

export default AdministrativeUnitManagement;